<template>
	<div>
        <b-modal id="modal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" :title="title" size="lg" @ok="ok" @hidden="hidden" @cancel="cancel" @shown="shown" :ok-disabled="this.$store.state.ajax_in_progress || (model.id != null && !$store.getters.hasPermission(['project'], ['update']))">
            <div class="row">
                <div class="col-lg-3">
                    <label>{{ $t('table.project_name') }}</label>
                </div>
                <div class="col-lg-9">
                    <input type="text" maxlength="5000" class="form-control" v-model="model.name">
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3">
                    <label>{{ $t('table.short_project_description') }}</label>
                </div>
                <div class="col-lg-9 mt-2">
                    <textarea rows="6" maxlength="5000" class="form-control resize_vertical" v-model="model.short_project_description"></textarea>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.project_contract_type') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <select class="form-control" v-model="model.project_contract_type">
                        <option v-for="project_contract_type in project_contract_types" :value="project_contract_type.code" :key="project_contract_type.code">
                            {{project_contract_type.name}}
                        </option>
                    </select>
                </div>

                <div class="col-sm-6 col-lg-3 mt-1">
                    <label for="project_type">{{ $t('table.project_type') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <select class="form-control" v-model="model.project_type">
                        <option v-for="project_type in project_types" :value="project_type.code" :key="project_type.code">
                            {{project_type.name}}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row mt-3" v-if="model.project_contract_type == 'others' || model.project_type == 'others'">
                <div class="col-sm-6 col-lg-3" v-if="model.project_contract_type == 'others'">
                    <label>{{ $t('table.other_project_contract_type') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3" v-if="model.project_contract_type == 'others'">
                    <input type="text" maxlength="5000" class="form-control" v-model="model.other_project_contract_type">
                </div>
                <div class="col-sm-6 col-lg-3" v-if="model.project_type == 'others'">
                    <label>{{ $t('table.other_project_type') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3" v-if="model.project_type == 'others'">
                    <input type="text" maxlength="5000" class="form-control" v-model="model.other_project_type">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.start_date') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.start_date"></flat-pickr>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.end_date') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.end_date"></flat-pickr>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.own_project_number') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="5000" class="form-control" v-model="model.own_project_number">
                </div>
                <div class="col-sm-6 col-lg-3 mt-1">
                    <label>{{ $t('table.status') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <select class="form-control" v-model="model.status">
                        <option v-for="status in statuses" :value="status.code" :key="status.code">{{status.name}}</option>
                    </select>
                </div>

                <div class="col-sm-6 col-lg-3 mt-3">
                    <label>{{ $t('table.seller_company') }}</label>
                </div>
                <div class="col-sm-6 col-lg-9 mt-3">
                    <multiselect v-model="selectedCompany4"
                        :options="currentCompany4"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isCompany4Loading"
                        :preserve-search="true"
                        placeholder=""
                        label="name" track-by="id"
                        :selectLabel="''"
                        @search-change="onCompany4Search"
                        @input="updateCompany4"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedCompany4 != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedCompany4"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 mt-3">
                    <hr>
                    <h5>{{ $t('table.own_information') }}</h5>
                    <hr>
                </div>
                <div class="col-lg-3">
                    <label>{{ $t('table.main_company') }}</label>
                </div>
                <div class="col-lg-8">
                    <multiselect v-model="selectedCompany"
                        :options="currentCompany"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isCompanyLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="name" track-by="id"
                        :selectLabel="''"
                        @search-change="onCompanySearch"
                        @input="updateCompany"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedCompany != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedCompany"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
                <div class="col-lg-1">
                    <i class="fa fa-plus-circle mr-1 fa-2x cursor-pointer mt-2" @click="goToCompanies"></i>
                </div>
            </div>
            <div class="row mt-3" v-if="model.main_company != null">
                <div class="col-sm-6 col-lg-3">
                    <label for="project_manager">{{ $t('table.project_manager') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <multiselect v-model="selectedMainPM"
                        :options="currentMainPM"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isMainPMLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onMainPMSearch"
                        @input="updateMainPM"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedMainPM != null && typeof selectedMainPM.id != 'undefined' && selectedMainPM.id != null"
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedMainPM"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>

                <div class="col-sm-6 col-lg-3 mt-1">
                    <label for="commercial_manager">{{ $t('table.commercial_manager') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <multiselect v-model="selectedMainCM"
                        :options="currentMainCM"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isMainCMLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onMainCMSearch"
                        @input="updateMainCM"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedMainCM != null && typeof selectedMainCM.id != 'undefined' && selectedMainCM.id != null"
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedMainCM"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 mt-3">
                    <hr>
                    <h5>{{ $t('table.client_information') }}</h5>
                    <hr>
                </div>
                <div class="col-lg-3">
                    <label for="client">{{ $t('table.general_contractor_name') }}</label>
                </div>
                <div class="col-lg-8">
                    <multiselect v-model="selectedCompany2"
                        :options="currentCompany2"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isCompany2Loading"
                        :preserve-search="true"
                        placeholder=""
                        label="name" track-by="id"
                        :selectLabel="''"
                        @search-change="onCompany2Search"
                        @input="updateCompany2"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedCompany2 != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedCompany2"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
                <div class="col-lg-1">
                    <i class="fa fa-plus-circle mr-1 fa-2x cursor-pointer mt-2" @click="goToCompanies"></i>
                </div>
            </div>

            <div class="row mt-3" v-if="model.general_contractor != null">
                <div class="col-sm-6 col-lg-3">
                    <label for="project_manager">{{ $t('table.project_manager') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <multiselect v-model="selectedGeneralPM"
                        :options="currentGeneralPM"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isGeneralPMLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onGeneralPMSearch"
                        @input="updateGeneralPM"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedGeneralPM != null && typeof selectedGeneralPM.id != 'undefined' && selectedGeneralPM.id != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedGeneralPM"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>

                <div class="col-sm-6 col-lg-3 mt-1">
                    <label for="commercial_manager">{{ $t('table.commercial_manager') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <multiselect v-model="selectedGeneralCM"
                        :options="currentGeneralCM"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isGeneralCMLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onGeneralCMSearch"
                        @input="updateGeneralCM"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedGeneralCM != null && typeof selectedGeneralCM.id != 'undefined' && selectedGeneralCM.id != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedGeneralCM"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>

            <div class="row mt-2" v-if="model.general_contractor != null">
                <div class="col-sm-6 col-lg-3">
                    <label for="contractor_pm_phone_no">{{ $t('table.pm_phone_number') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <div v-if="selectedGeneralPM">
                        <input disabled v-model="selectedGeneralPM.phone_no" type="text" required autofocus class="form-control">
                    </div>
                    <div v-else>
                        <input disabled type="text" required autofocus class="form-control">
                    </div>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label for="contractor_phone_number_commercial_manager">{{ $t('table.phone_number_commercial_manager') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <div v-if="selectedGeneralCM">
                        <input disabled v-model="selectedGeneralCM.phone_no" id="contractor_phone_number_commercial_manager" name="contractor_phone_number_commercial_manager" type="text" required autofocus class="form-control">
                    </div>
                    <div v-else>
                        <input disabled id="contractor_phone_number_commercial_manager" name="contractor_phone_number_commercial_manager" type="text" required autofocus class="form-control">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 mt-3">
                    <hr class="mb-1">
                        <div class="row">
                            <h5 class="col-lg-11 mr-3 mt-2">{{ $t('table.subcontractors') }}</h5>
                            <i class="fa fa-plus-circle fa-2x cursor-pointer mt-2" @click="addSubcontractor"></i>
                        </div>
                    <hr class="mt-2">
                </div>
            </div>
            <div class="row mb-2" v-for="(subcontractor, idx) in selectedSubcontractors" :key="idx">
                <div class="col-lg-3">
                    <label>{{ $t('table.subcontractor_name') }}</label>
                </div>
                <div class="col-lg-7">
                    <multiselect v-model="subcontractor.selected"
                        :options="subcontractor.current"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="subcontractor.isLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="name" track-by="id"
                        :selectLabel="''"
                        @search-change="onSubcontractorSearch($event, idx)"
                        @input="updateSubcontractor($event, idx)"
                    >
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
                <div class="closeBtn col-lg-1">
                    <i class="fa fa-2x mt-1 fa-times float-right cursor-pointer" @click="deleteCard(idx)"></i>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 mt-3">
                    <hr>
                    <h5>{{ $t('table.final_client') }}</h5>
                    <hr>
                </div>
                <div class="col-lg-3">
                    <label for="final_client">{{ $t('table.final_client_name') }}</label>
                </div>
                <div class="col-lg-8">
                    <multiselect v-model="selectedCompany3"
                        :options="currentCompany3"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isCompany3Loading"
                        :preserve-search="true"
                        placeholder=""
                        label="name" track-by="id"
                        :selectLabel="''"
                        @search-change="onCompany3Search"
                        @input="updateCompany3"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedCompany3 != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedCompany3"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
                <div class="col-lg-1">
                    <i class="fa fa-plus-circle mr-1 fa-2x cursor-pointer mt-2" @click="goToCompanies"></i>
                </div>
            </div>
            <div class="row mt-3" v-if="model.final_client != null">
                <div class="col-sm-6 col-lg-3">
                    <label for="project_manager">{{ $t('table.project_manager') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <multiselect v-model="selectedFinalPM"
                        :options="currentFinalPM"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isFinalPMLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onFinalPMSearch"
                        @input="updateFinalPM"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedFinalPM != null && typeof selectedFinalPM.id != 'undefined' && selectedFinalPM.id != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedFinalPM"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>

                <div class="col-sm-6 col-lg-3 mt-1">
                    <label for="commercial_manager">{{ $t('table.commercial_manager') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <multiselect v-model="selectedFinalCM"
                        :options="currentFinalCM"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isFinalCMLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onFinalCMSearch"
                        @input="updateFinalCM"
                    >
                        <template slot="clear" slot-scope="props">
                            <div 
                                v-if="selectedFinalCM != null && typeof selectedFinalCM.id != 'undefined' && selectedFinalCM.id != null" 
                                class="multiselect__clear" 
                                @mousedown.prevent.stop="clearSelectedFinalCM"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <hr>
                    <h5>{{ $t('table.construction_site_information') }}</h5>
                    <hr>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.site_location_name') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="5000" class="form-control" v-model="model.site_location_name">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.address') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="5000" class="form-control" v-model="model.site_location_address">
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.delivery_conditions') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <select class="form-control" v-model="model.delivery_conditions">
                        <option v-for="delivery_conditions in conditions" :value="delivery_conditions.code" :key="delivery_conditions.code">{{delivery_conditions.name}}</option>
                    </select>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.contract_language') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="5000" class="form-control" v-model="model.contract_language">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <hr>
                        <h5>{{ $t('table.commercial_information') }}</h5>
                    <hr>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.contract_value') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.contract_value">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.contract_currency') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <select v-model="model.contract_currency" class="form-control" size="1">
                        <option v-for="currency in currencies" :value="currency.code" :key="currency.code">{{currency.name}}</option>
                    </select>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.payment_terms') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.payment_terms">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.payment_condition') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.payment_condition">
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.advance_payment') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input v-model="model.advance_payment" type="text" required autofocus class="form-control">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.warranty_bond') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input v-model="model.warranty_bond" type="text" required autofocus class="form-control">
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.performance_bond') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.performance_bond">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.bid_bond') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.bid_bond">
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.warranty_period') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.warranty_period">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.third_party_liability_insurance_value') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.third_party_liability_insurance_value">
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.ear_insurance_value') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.ear_insurance_value">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.product_liability_insurance_value') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.product_liability_insurance_value">
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.workman_compensation_insurance_value') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.workman_compensation_insurance_value">
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.cargo_insurance_value') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.cargo_insurance_value">
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-6 col-lg-3">
                    <label>{{ $t('table.other_insurance_value') }}</label>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <input type="text" maxlength="250" class="form-control" v-model="model.other_insurance_value">
                </div>
            </div>
        </b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';

export default {
    name: 'ProjectModal',
    components: {
        flatPickr,
        Multiselect,
    },
    props: {
        model: {
            type: Object,
            default: () => ({
                subcontractors: null,
                disciplines: [],
                companies: [],
                name: null,
                status: null,
                own_project_number: null,
                project_contract_type: null,
                other_project_contract_type: null,
                project_type: null,
                other_project_type: null,
                short_project_description: null,
                start_date: null,
                end_date: null,
                site_location_name: null,
                site_location_address: null,
                delivery_conditions: null,
                contract_language: null,
                contract_value: null,
                contract_currency: null,
                payment_terms: null,
                payment_condition: null,
                advance_payment: null,
                warranty_bond: null,
                performance_bond: null,
                bid_bond: null,
                warranty_period: null,
                third_party_liability_insurance_value: null,
                ear_insurance_value: null,
                product_liability_insurance_value: null,
                workman_compensation_insurance_value: null,
                cargo_insurance_value: null,
                other_insurance_value: null,

                main_company: null,
                seller_type: null,
                seller_type_company: null,
                main_project_manager: null,
                main_commercial_manager: null,

                general_contractor: null,
                general_project_manager: null,
                general_commercial_manager: null,

                final_client: null,
                final_project_manager: null,
                final_commercial_manager: null,
            })
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tableNameTranslated: Vue.i18n.translate('general.projects.title_modal'),

            //check if already opened
            already_opened_warning: false,
            //end check if already opened

            selectedCompany4: null,
            currentCompany4: [],
            isCompany4Loading: false,

            selectedCompany: null,
            currentCompany: [],
            isCompanyLoading: false,

            selectedMainPM: null,
            isMainPMLoading: false,
            currentMainPM: [],

            selectedMainCM: null,
            isMainCMLoading: false,
            currentMainCM: [],

            selectedCompany2: null,
            isCompany2Loading: false,
            currentCompany2: [],

            selectedGeneralPM: null,
            isGeneralPMLoading: false,
            currentGeneralPM: [],

            selectedGeneralCM: null,
            isGeneralCMLoading: false,
            currentGeneralCM: [],

            selectedSubcontractors: [],

            selectedCompany3: null,
            isCompany3Loading: false,
            currentCompany3: [],

            selectedFinalPM: null,
            isFinalPMLoading: false,
            currentFinalPM: [],

            selectedFinalCM: null,
            isFinalCMLoading: false,
            currentFinalCM: [],

            getData: {
                rowData: [],
                getDisciplines: {
                    fromMain: [],
                    fromGeneral: [],
                    all: []
                },
                getFinalClients: [],
                getClients: [],
                getProjects: []
            }
        }
    },
    computed: {
        project_contract_types: {
            get: function () {
                let project_contract_types = this.$store.getters.getProjectContractTypes;
                return project_contract_types;
            }
        },
        project_types: {
            get: function () {
                let project_types = this.$store.getters.getProjectTypes;
                return project_types;
            }
        },
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getProjectStatuses;
                return statuses;
            }
        },
        currencies: {
            get: function () {
                let currencies = this.$store.getters.getCurrencies;
                return currencies;
            }
        },
        conditions: {
            get: function () {
                let conditions = this.$store.getters.getProjectConditions;
                return conditions;
            }
        },
    },
    watch: {
        project_contract_types: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        project_types: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        currencies: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        conditions: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    mounted () {
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 5000);
        },
        hidden(e) {
            this.cancel(e);
            this.$emit('hidden', e);
        },
        goToCompanies(e) {
            let data = {
                key: 'projects',
                value: {
                    model: this.model,
                    selectedCompany: this.selectedCompany,
                    selectedMainPM: this.selectedMainPM,
                    selectedMainCM: this.selectedMainCM,

                    selectedCompany2: this.selectedCompany2,
                    selectedGeneralPM: this.selectedGeneralPM,
                    selectedGeneralCM: this.selectedGeneralCM,

                    selectedCompany3: this.selectedCompany3,
                    selectedFinalPM: this.selectedFinalPM,
                    selectedFinalCM: this.selectedFinalCM,

                    selectedCompany4: this.selectedCompany4,
                }
            }

            this.$store.commit('SET_BACKDATA_LIST', data);
            this.$store.commit('SET_BACKURL', 'projects');
            this.$store.commit('SET_CAMEFROM', 'projects');

            this.$router.push({name: 'companies'});
        },
        clear () {
            this.model.disciplines = null;
            this.model.companies = null;
            this.model.main_company = null;
            this.model.seller_type = null;
            this.model.seller_type_company = null;
            this.model.name = null;
            this.model.status = null;
            this.model.own_project_number = null;
            this.model.project_contract_type = null;
            this.model.other_project_contract_type = null;
            this.model.project_type = null;
            this.model.other_project_type = null;
            this.model.short_project_description = null;
            this.model.start_date = null;
            this.model.end_date = null;
            this.model.client = null;
            this.model.final_client = null;
            this.model.site_location_name = null;
            this.model.site_location_address = null;
            this.model.delivery_conditions = null;
            this.model.contract_language = null;
            this.model.contract_value = null;
            this.model.contract_currency = null;
            this.model.payment_terms = null;
            this.model.payment_condition = null;
            this.model.advance_payment = null;
            this.model.warranty_bond = null;
            this.model.performance_bond = null;
            this.model.bid_bond = null;
            this.model.warranty_period = null;
            this.model.third_party_liability_insurance_value = null;
            this.model.ear_insurance_value = null;
            this.model.product_liability_insurance_value = null;
            this.model.workman_compensation_insurance_value = null;
            this.model.cargo_insurance_value = null;
            this.model.other_insurance_value = null;

            this.model.project_manager = null;
            this.model.commercial_manager = null;

            this.model.contractor_address = null;
            this.model.contractor_pm_client = null;
            this.model.contractor_pm_phone_no = null;
            this.model.contractor_client_commercial_manager = null;
            this.model.contractor_phone_number_commercial_manager = null;

            this.model.client_address = null;
            this.model.pm_final_client = null;
            this.model.client_pm_phone_number = null;

            this.getData.getDisciplines.all = [];

            this.selectedCompany4  = null;
            this.selectedCompany   = null;
            this.selectedMainPM    = null;
            this.selectedMainCM    = null;
            this.selectedCompany2  = null;
            this.selectedGeneralPM = null;
            this.selectedGeneralCM = null;
            this.model.subcontractors = [];
            this.selectedCompany3  = null;
            this.selectedFinalPM   = null;
            this.selectedFinalCM   = null;

            this.currentCompany4  = [];
            this.currentCompany   = [];
            this.currentMainPM    = [];
            this.currentMainCM    = [];
            this.currentCompany2  = [];
            this.currentGeneralPM = [];
            this.currentGeneralCM = [];
            this.selectedSubcontractors = [];
            this.currentCompany3  = [];
            this.currentFinalPM   = [];
            this.currentFinalCM   = [];
        },
        __loadCompanies(companies) {
            this.selectedCompany = companies['selectedCompany'];
            this.selectedMainPM = companies['selectedMainPM']
            this.selectedMainCM = companies['selectedMainCM']
            this.selectedCompany2 = companies['selectedCompany2']
            this.selectedGeneralPM = companies['selectedGeneralPM']
            this.selectedGeneralCM = companies['selectedGeneralCM']
            this.selectedCompany3 = companies['selectedCompany3']
            this.selectedFinalPM = companies['selectedFinalPM']
            this.selectedFinalCM = companies['selectedFinalCM']
            this.selectedCompany4 = companies['selectedCompany4']
        },
        loadVals(row) {
            this.model.id = row.id;
            this.model.companies = row.companies;
            this.model.disciplines = row.disciplines;
            this.model.subcontractors = [];
            this.model.name = row.name;
            this.model.status = row.status;
            this.model.own_project_number = row.own_project_number;
            this.model.project_contract_type = row.project_contract_type;
            this.model.other_project_contract_type = row.other_project_contract_type;
            this.model.project_type = row.project_type;
            this.model.other_project_type = row.other_project_type;
            this.model.short_project_description = row.short_project_description;
            this.model.start_date = row.start_date;
            this.model.end_date = row.end_date;
            this.model.site_location_name = row.site_location_name;
            this.model.site_location_address = row.site_location_address;
            this.model.delivery_conditions = row.delivery_conditions;
            this.model.contract_language = row.contract_language;
            this.model.contract_value = row.contract_value;
            this.model.contract_currency = row.contract_currency;
            this.model.payment_terms = row.payment_terms;
            this.model.payment_condition = row.payment_condition;
            this.model.advance_payment = row.advance_payment;
            this.model.warranty_bond = row.warranty_bond;
            this.model.performance_bond = row.performance_bond;
            this.model.bid_bond = row.bid_bond;
            this.model.warranty_period = row.warranty_period;
            this.model.third_party_liability_insurance_value = row.third_party_liability_insurance_value;
            this.model.ear_insurance_value = row.ear_insurance_value;
            this.model.product_liability_insurance_value = row.product_liability_insurance_value;
            this.model.workman_compensation_insurance_value = row.workman_compensation_insurance_value;
            this.model.cargo_insurance_value = row.cargo_insurance_value;
            this.model.other_insurance_value = row.other_insurance_value;

            this.model.project_manager = row.project_manager;
            this.model.commercial_manager = row.commercial_manager;

            this.model.contractor_address = row.contractor_address;
            this.model.contractor_pm_client = row.contractor_pm_client;
            this.model.contractor_pm_phone_no = row.contractor_pm_phone_no;
            this.model.contractor_client_commercial_manager = row.contractor_client_commercial_manager;
            this.model.contractor_phone_number_commercial_manager = row.contractor_phone_number_commercial_manager;

            this.model.client_address = row.client_address;
            this.model.pm_final_client = row.pm_final_client;
            this.model.client_pm_phone_number = row.client_pm_phone_number;

            this.model.construction_company_id = row.construction_company_id;
            this.model.contractor_id = row.contractor_id;
            this.model.final_client_id = row.final_client_id;
            this.model.seller_type = row.seller_type_company.id;
            this.model.seller_type_company = row.seller_type_company;

            this.selectedCompany4       = null;
            this.selectedCompany        = null;
            this.selectedMainPM         = null;
            this.selectedMainCM         = null;
            this.selectedCompany2       = null;
            this.selectedGeneralPM      = null;
            this.selectedGeneralCM      = null;
            this.selectedSubcontractors = [];
            this.selectedCompany3       = null;
            this.selectedFinalPM        = null;
            this.selectedFinalCM        = null;

            if (this.model.seller_type && row.seller_type_company) {
                this.selectedCompany4 = [{name: row.seller_type_company.name, id: row.seller_type_company.id}];
            }

            if (this.model.companies != 'undefined' && this.model.companies != null) {
                this.model.companies.forEach((value, key) => {
                    switch(value.pivot.type) {
                        case 'main':
                            this.selectedCompany = {
                                id: value.id,
                                name: value.name, 
                            };

                            this.selectedMainPM = {
                                id: value.pivot.project_manager_id, 
                                fullname: value.pivot.project_manager, 
                                phone_no: value.pivot.project_manager_phoneno,
                            };

                            this.selectedMainCM = {
                                id: value.pivot.commercial_manager_id, 
                                fullname: value.pivot.commercial_manager, 
                                phone_no: value.pivot.commercial_manager_phoneno,
                            };

                            this.model.main_company            = value.id;
                            this.model.main_project_manager    = value.pivot.project_manager_id;
                            this.model.main_commercial_manager = value.pivot.commercial_manager_id;
                            break;
                        case 'general':
                            this.selectedCompany2 = {
                                name: value.name, id: 
                                value.id
                            };
                            this.selectedGeneralPM = {
                                id: value.pivot.project_manager_id, 
                                fullname: value.pivot.project_manager, 
                                phone_no: value.pivot.project_manager_phoneno,
                            };

                            this.selectedGeneralCM = {
                                id: value.pivot.commercial_manager_id, 
                                fullname: value.pivot.commercial_manager, 
                                phone_no: value.pivot.commercial_manager_phoneno,
                            };

                            this.model.general_contractor         = value.id;
                            this.model.general_project_manager    = value.pivot.project_manager_id;
                            this.model.general_commercial_manager = value.pivot.commercial_manager_id;
                            break;
                        case 'final':
                            this.selectedCompany3 = {
                                id: value.id,
                                name: value.name, 
                            };

                            this.selectedFinalPM = {
                                id: value.pivot.project_manager_id, 
                                fullname: value.pivot.project_manager, 
                                phone_no: value.pivot.project_manager_phoneno,
                            };

                            this.selectedFinalCM = {
                                id: value.pivot.commercial_manager_id, 
                                fullname: value.pivot.commercial_manager, 
                                phone_no: value.pivot.commercial_manager_phoneno,
                            };

                            this.model.final_client             = value.id;
                            this.model.final_project_manager    = value.pivot.project_manager_id;
                            this.model.final_commercial_manager = value.pivot.commercial_manager_id;
                            break;
                        case 'subcontractor':
                            this.selectedSubcontractors.push({'isLoading': false, 'current': [], 'selected': [{name: value.name, id: value.id}]});
                            this.model.subcontractors.push(value.id);
                            break;
                    }
                });
            }
        },
        async ok(e) {
            e.preventDefault();
            
            let data = {
                name: this.model.name,
                main_company: this.model.main_company,
                seller_type: this.model.seller_type,
                seller_type_company: this.model.seller_type_company,
                main_project_manager: this.model.main_project_manager,
                main_commercial_manager: this.model.main_commercial_manager,

                general_contractor: this.model.general_contractor,
                general_project_manager: this.model.general_project_manager,
                general_commercial_manager: this.model.general_commercial_manager,

                final_client: this.model.final_client,
                final_project_manager: this.model.final_project_manager,
                final_commercial_manager: this.model.final_commercial_manager,
                status: this.model.status,
                own_project_number: this.model.own_project_number,
                project_contract_type: this.model.project_contract_type,
                other_project_contract_type: this.model.other_project_contract_type,
                project_type: this.model.project_type,
                other_project_type: this.model.other_project_type,
                short_project_description: this.model.short_project_description,
                start_date: this.model.start_date,
                end_date: this.model.end_date,
                site_location_name: this.model.site_location_name,
                site_location_address: this.model.site_location_address,
                delivery_conditions: this.model.delivery_conditions,
                contract_language: this.model.contract_language,
                contract_value: this.model.contract_value,
                contract_currency: this.model.contract_currency,
                payment_terms: this.model.payment_terms,
                payment_condition: this.model.payment_condition,
                advance_payment: this.model.advance_payment,
                warranty_bond: this.model.warranty_bond,
                performance_bond: this.model.performance_bond,
                bid_bond: this.model.bid_bond,
                warranty_period: this.model.warranty_period,
                third_party_liability_insurance_value: this.model.third_party_liability_insurance_value,
                ear_insurance_value: this.model.ear_insurance_value,
                product_liability_insurance_value: this.model.product_liability_insurance_value,
                workman_compensation_insurance_value: this.model.workman_compensation_insurance_value,
                cargo_insurance_value: this.model.cargo_insurance_value,
                other_insurance_value: this.model.other_insurance_value,
                report: 0,
                subcontractors: this.model.subcontractors,
            }

            Object.keys(data).forEach(key => {
                if (data[key] === '') {
                    data[key] = null;
                }
            });

            if (this.model.id != null && (typeof this.model.id != 'undefined')) {
                data['id'] = this.model.id;
                //check if already opened
                data['already_opened_warning'] = this.already_opened_warning;
                //end check if already opened

                http.route('project/' + this.model.id).patch(data, true).then(response => {
                    if (response.isError == false) {
                        this.$emit('done', response.data);

                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$refs.saveModal.hide();

                        //check if already opened
                        this.already_opened_warning = false;
                        //end check if already opened
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            //check if already opened
                            if (response.errorMessage[key] == 'misc.document_already_opened') {
                                this.already_opened_warning = true;
                                this.errorMsg(Vue.i18n.translate('misc.document_already_opened'));
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                            //end check if already opened
                        });
                    }
                });
            } else {
                http.route('project').post(data, true).then(response => {
                    if (response.isError == false) {
                        this.$emit('done', response.data);

                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        this.$refs.saveModal.hide();

                        this.$router.push('project/'+response.data.id);
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }

            this.$emit('ok', e);
        },
        cancel(e) {
            if (this.model.id != null) {
                //check if already opened
                this.already_opened_warning = false;
                let data = {
                    id: this.model.id,
                    object_is_opened_now: 0,
                };
                http.route('project/' + this.model.id).patch(data, true);
                //end check if already opened
            }

            this.$emit('cancel', e);
        },
        shown(e) {
			this.$emit('shown', e);
        },
        show() {
            if (this.selectedSubcontractors.length < 1) {
                this.addSubcontractor();
            }

            if (this.model.id != null) {
                //check if already opened
                this.already_opened_warning = false;
                let data = {
                    id: this.model.id,
                    object_is_opened_now: 1,
                };
                http.route('project/' + this.model.id).patch(data, true).then(response => {
                    if (response.isError == false) {
                        if (typeof response.data != 'undefined') {
                            if (response.data.opened_by != this.$store.state.user.user.id) {
                                this.warnMsg(Vue.i18n.translate('misc.document_is_open'));                       
                            }
                        }
                    }
                });
                //end check if already opened
            }

            this.$refs.saveModal.show();
        },
        hide() {
            this.model.subcontractors = [];
            this.$refs.saveModal.hide();
        },

        //Seller Company
        onCompany4Search(search) {
            if (search == '') {
                this.currentCompany4 = [];
                
                return false;
            }

            this.isCompany4Loading = true;
            this.searchCompany4(search, this);
        },
        searchCompany4: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany4 = response.data;
                }
                vm.isCompany4Loading = false;
            });
        }, 500),
        updateCompany4(company4) {
            this.model.seller_type = (company4 != null) ? company4.id : null;
        },
        clearSelectedCompany4 () {
            this.selectedCompany4  = null;
            this.model.seller_type = null;
            this.model.seller_type_company = null;
        },

        //Main Construction Company Information
        onCompanySearch(search) {
            if (search == '') {
                this.currentCompany = [];
                
                return false;
            }

            this.isCompanyLoading = true;
            this.searchCompany(search, this);
        },
        searchCompany: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany = response.data;
                }
                vm.isCompanyLoading = false;
            });
        }, 500),
        updateCompany(company) {
            this.currentMainPM  = [];
            this.currentMainCM  = [];
            this.selectedMainPM = null;
            this.selectedMainCM = null;

            this.model.main_company = (company != null) ? company.id : null;
        },
        clearSelectedCompany () {
            this.selectedCompany    = null;
            this.model.main_company = null;
        },

        //Main Construction Company Information - Project Manager
        onMainPMSearch(search) {
            if (search == '') {
                this.currentMainPM = [];
                
                return false;
            }

            if (this.model.main_company != null) {
                this.isMainPMLoading = true;
                this.searchMainPM(search, this);
            }
        },
        searchMainPM: _.debounce((search, vm) => {
            let data = http.route('user/getall?filters[company_id]=' + vm.model.main_company + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentMainPM = response.data;
                }
                vm.isMainPMLoading = false;
            });
        }, 500),
        updateMainPM(user) {
            this.model.main_project_manager = (user != null) ? user.id : null;
        },
        clearSelectedMainPM () {
            this.selectedMainPM             = null;
            this.model.main_project_manager = null;
        },

        //Main Construction Company Information - Commercial Manager
        onMainCMSearch(search) {
            if (search == '') {
                this.currentMainCM = [];
                
                return false;
            }

            if (this.model.main_company != null) {
                this.isMainCMLoading = true;
                this.searchMainCM(search, this);
            }
        },
        searchMainCM: _.debounce((search, vm) => {
            let data = http.route('user/getall?filters[company_id]=' + vm.model.main_company + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentMainCM = response.data;
                }
                vm.isMainCMLoading = false;
            });
        }, 500),
        updateMainCM(user) {
            this.model.main_commercial_manager = (user != null) ? user.id : null;
        },
        clearSelectedMainCM () {
            this.selectedMainCM                = null;
            this.model.main_commercial_manager = null;
        },

        //General Contractor Information
        onCompany2Search(search) {
            if (search == '') {
                this.currentCompany2 = [];
                
                return false;
            }

            this.isCompany2Loading = true;
            this.searchCompany2(search, this);
        },
        searchCompany2: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany2 = response.data;
                }
                vm.isCompany2Loading = false;
            });
        }, 500),
        updateCompany2(company2) {
            this.currentGeneralPM = [];
            this.currentGeneralCM = [];
            this.selectedGeneralPM = null;
            this.selectedGeneralCM = null;

            this.model.general_contractor = (company2 != null) ? company2.id : null;
        },
        clearSelectedCompany2 () {
            this.selectedCompany2         = null;
            this.model.general_contractor = null;
        },

        //General Contractor Information - Project Manager
        onGeneralPMSearch(search) {
            if (search == '') {
                this.currentGeneralPM = [];
                
                return false;
            }

            if (this.model.general_contractor != null) {
                this.isGeneralPMLoading = true;
                this.searchGeneralPM(search, this);
            }
        },
        searchGeneralPM: _.debounce((search, vm) => {
            let data = http.route('user/getall?filters[company_id]=' + vm.model.general_contractor + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentGeneralPM = response.data;
                }
                vm.isGeneralPMLoading = false;
            });
        }, 500),
        updateGeneralPM(user) {
            this.model.general_project_manager = (user != null) ? user.id : null;
        },
        clearSelectedGeneralPM () {
            this.selectedGeneralPM             = null;
            this.model.general_project_manager = null;
        },

        //General Contractor Information - Commercial Manager
        onGeneralCMSearch(search) {
            if (search == '') {
                this.currentGeneralCM = [];
                
                return false;
            }

            if (this.model.general_contractor != null) {
                this.isGeneralCMLoading = true;
                this.searchGeneralCM(search, this);
            }
        },
        searchGeneralCM: _.debounce((search, vm) => {
            let data = http.route('user/getall?filters[company_id]=' + vm.model.general_contractor + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentGeneralCM = response.data;
                }
                vm.isGeneralCMLoading = false;
            });
        }, 500),
        updateGeneralCM(user) {
            this.model.general_commercial_manager = (user != null) ? user.id : null;
        },
        clearSelectedGeneralCM () {
            this.selectedGeneralCM                = null;
            this.model.general_commercial_manager = null;
        },

        //Subcontractors
        onSubcontractorSearch(search, idx) {
            if (search == '') {
                this.selectedSubcontractors[idx].current = [];
                
                return false;
            }

            this.selectedSubcontractors[idx].current = [];
            this.selectedSubcontractors[idx].isLoading = true;
            this.searchSubcontractor(search, this, idx);
        },
        searchSubcontractor: _.debounce((search, vm, idx) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.selectedSubcontractors[idx].current = response.data;
                }
                vm.selectedSubcontractors[idx].isLoading = false;
            });
        }, 500),
        updateSubcontractor(subcontractor, idx) {
            if (subcontractor == null || typeof this.model.subcontractors == 'undefined') {
                this.model.subcontractors = [];
            }

            if (this.model.subcontractors.indexOf(subcontractor.id) == -1) {
                this.model.subcontractors.push(subcontractor.id);
            }
        },
        clearSelectedSubcontractor(idx) {
            this.selectedSubcontractors.splice(idx, 1);
        },
        addSubcontractor () {
            this.selectedSubcontractors.push({'isLoading': false, 'current': [], 'selected': {}});
        },
        deleteCard (idx) {
            if (this.selectedSubcontractors.length == 1) {
                this.errorMsg(Vue.i18n.translate('messages.at_least_one_subcontractor'));
                return 0;
            } else {
                this.selectedSubcontractors.splice(idx, 1);
                this.model.subcontractors.splice(idx, 1);
            }
        },

        //Final Client
        onCompany3Search(search) {
            if (search == '') {
                this.currentCompany3 = [];
                
                return false;
            }

            this.isCompany3Loading = true;
            this.searchCompany3(search, this);
        },
        searchCompany3: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany3 = response.data;
                }
                vm.isCompany3Loading = false;
            });
        }, 500),
        updateCompany3(company3) {
            this.currentFinalPM = [];
            this.currentFinalCM = [];
            this.selectedFinalPM = null;
            this.selectedFinalCM = null;

            this.model.final_client = (company3 != null) ? company3.id : null;
        },
        clearSelectedCompany3 () {
            this.selectedCompany3   = null;
            this.model.final_client = null;
        },

        //Final Client - Project Manager
        onFinalPMSearch(search) {
            if (search == '') {
                this.currentFinalPM = [];
                
                return false;
            }

            if (this.model.final_client != null ) {
                this.isFinalPMLoading = true;
                this.searchFinalPM(search, this);
            }
        },
        searchFinalPM: _.debounce((search, vm) => {
            let data = http.route('user/getall?filters[company_id]=' + vm.model.final_client + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentFinalPM = response.data;
                }
                vm.isFinalPMLoading = false;
            });
        }, 500),
        updateFinalPM(user) {
            this.model.final_project_manager = (user != null) ? user.id : null;
        },
        clearSelectedFinalPM () {
            this.selectedFinalPM             = null;
            this.model.final_project_manager = null;
        },

        //Final Client - Commercial Manager
        onFinalCMSearch(search) {
            if (search == '') {
                this.currentFinalCM = [];
                
                return false;
            }

            if (this.model.final_client != null ) {
                this.isFinalCMLoading = true;
                this.searchFinalCM(search, this);
            }
        },
        searchFinalCM: _.debounce((search, vm) => {
            let data = http.route('user/getall?filters[company_id]=' + vm.model.final_client + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentFinalCM = response.data;
                }
                vm.isFinalCMLoading = false;
            });
        }, 500),
        updateFinalCM(user) {
            this.model.final_commercial_manager = (user != null) ? user.id : null;
        },
        clearSelectedFinalCM () {
            this.selectedFinalCM                = null;
            this.model.final_commercial_manager = null;
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }

    .multiselect-custom {
        width: 300px !important;
        height: 40px !important;
    }
    .multiselect__input:focus {
        width: 100% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/modals/ProjectModal.vue